// extracted by mini-css-extract-plugin
export default {"Time":"ClinicSessionTime_Time__woHxp"};